<div class="navbar-layout" id="navbar">
  <mat-toolbar class="menu-bar">
    <mat-toolbar-row>
      <button mat-icon-button (click)="sidenav.toggle()" fxShow="true"
        fxHide.gt-sm aria-label="Abrir menu">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="brand-menu-logo">
        <img src="../../../assets/img/wazir/wazir-logo-full.png" alt="WAZIR ERP" class="img-menu" />
      </span>

      <span style="flex: 1 1 auto"></span>
      <div>
        <div class="icon-buttons-container">
          <div class="navbar-module-search" *ngIf="!isHomeRoute" #moduleSearchRef>
            <label class="navbar-module-search__input">
              <mat-icon>search</mat-icon>
              <input type="text"
                placeholder="Buscar módulo..."
                [value]="moduleSearch"
                (input)="setModuleSearch($any($event.target).value)">
              <button *ngIf="moduleSearch" type="button"
                class="navbar-module-search__clear"
                matTooltip="Limpar"
                (click)="clearModuleSearch()">
                <mat-icon>close</mat-icon>
              </button>
            </label>
            <div class="navbar-module-search__results"
              *ngIf="moduleSearch && filteredModuleCards.length">
              <button type="button"
                class="navbar-module-search__result"
                *ngFor="let card of filteredModuleCards"
                (click)="navigateToModule(card)">
                <span class="navbar-module-search__icon"
                  [style.backgroundColor]="card.color">
                  <mat-icon>{{card.icon}}</mat-icon>
                </span>
                <span class="navbar-module-search__text">
                  <strong>{{card.title}}</strong>
                  <small>{{card.description}}</small>
                </span>
              </button>
            </div>
            <div class="navbar-module-search__results navbar-module-search__results--empty"
              *ngIf="moduleSearch && !filteredModuleCards.length">
              Nenhum módulo encontrado.
            </div>
          </div>
          <button *ngIf="!isHomeRoute" type="button" mat-icon-button
            class="theme-toggle-btn"
            [matTooltip]="darkMode ? 'Tema claro' : 'Tema escuro'"
            (click)="toggleTheme()">
            <mat-icon>{{darkMode ? 'light_mode' : 'dark_mode'}}</mat-icon>
          </button>
          <button *ngIf="!keyboardService.keyboardIsOpen()" mat-icon-button
            matTooltip="Abrir Teclado"
            (click)="keyboardService.openKeyboard()">
            <mat-icon>keyboard</mat-icon>
          </button>
          <button *ngIf="keyboardService.keyboardIsOpen()" mat-icon-button
            matTooltip="Fechar Teclado"
            (click)="keyboardService.closeKeyboard()">
            <mat-icon>keyboard_hide</mat-icon>
          </button>
          <button *ngIf="isFullScreen && isPossibleCloseFullScreen"
            mat-icon-button matTooltip="Fechar Tela Cheia"
            (click)="closeFullScreen()">
            <mat-icon>crop_landscape</mat-icon>
          </button>
          <button *ngIf="!isFullScreen" mat-icon-button matTooltip="Tela Cheia"
            (click)="openFullScreen()">
            <mat-icon>crop_free</mat-icon>
          </button>
          <app-barid-connectivity-indicator></app-barid-connectivity-indicator>
          <app-offline-indicator></app-offline-indicator>
          <app-notification></app-notification>
          <button class="profile-container" mat-button
            [matTooltip]="getProfileTooltip()"
            [matMenuTriggerFor]="accountMenu">
            <div fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="center center">
              <img class="image-label" [src]="getImageUrl()" />
              <span class="profile-text">
                <span class="username">{{ getDisplayName() }}</span>
                <span class="company-name" *ngIf="getTenantCompanyLabel()">{{ getTenantCompanyLabel() }}</span>
              </span>
            </div>
          </button>
        </div>

        <mat-menu #accountMenu [overlapTrigger]="false" yPosition="below">
          <button [matTooltip]="user.firstName + ' ' + user.lastName"
            mat-menu-item
            [routerLink]="['/users/view-profile/' + authService.getUserId()]">
            <mat-icon>person</mat-icon><span>Perfil</span>
          </button>
          <button mat-menu-item>
            <mat-icon>help</mat-icon><span>Ajuda</span>
          </button>
          <button mat-menu-item [routerLink]="['/users']">
            <mat-icon>settings</mat-icon><span>Usuários</span>
          </button>
          <button mat-menu-item (click)="openChangePassword()">
            <mat-icon>lock</mat-icon><span>Trocar senha</span>
          </button>
          <button *ngIf="branchOptions.length > 1" mat-menu-item (click)="openSelectBranch()">
            <mat-icon>store</mat-icon>
            <span>Trocar filial<span *ngIf="selectedBranchName"> ({{ selectedBranchName }})</span></span>
          </button>
          <button mat-menu-item (click)="clearCache()">
            <mat-icon>rotate_right</mat-icon><span>Limpar cache</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>Sair
          </button>
        </mat-menu>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="application-shell" [class.sidebar-collapsed]="isSidebarCollapsed">
    <aside class="desktop-sidebar" fxHide.lt-md>
      <app-side-nav-bar [menu]="menu"></app-side-nav-bar>
    </aside>
    <button
      type="button"
      class="sidebar-toggle"
      fxHide.lt-md
      mat-icon-button
      (click)="toggleSidebar()"
      [attr.aria-label]="isSidebarCollapsed ? 'Abrir menu lateral' : 'Fechar menu lateral'"
      [matTooltip]="isSidebarCollapsed ? 'Abrir menu lateral' : 'Fechar menu lateral'">
      <mat-icon>{{ isSidebarCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>

    <mat-sidenav-container>
      <mat-sidenav #sidenav mode="over" autoFocus="false" fxHide.gt-sm>
        <app-side-nav-bar [menu]="menu"
          (onClose)="closeSideNav()"></app-side-nav-bar>
      </mat-sidenav>
      <mat-sidenav-content>
        <ng-content></ng-content>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
